import useTicketNavigation from "../../../hooks/useTicketNavigation/useTicketNavigation";

const withNavigation = (WrappedComponent: any) => {
  return (props: any) => {
    const handleRedirect = useTicketNavigation();

    return <WrappedComponent {...props} onClick={handleRedirect} />;
  };
};
export default withNavigation